export default __webpack_public_path__ + "static/media/direct.00e6e407.png";